import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2GroupIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47 47",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47),
    children: [/*#__PURE__*/jsx("circle", {
      cx: "8.5",
      cy: "11.5",
      r: "4.5"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.5 19A7.5 7.5 0 001 26.5V31h3l1.5 12h6"
    }), /*#__PURE__*/jsx("circle", {
      cx: "38.5",
      cy: "11.5",
      r: "4.5"
    }), /*#__PURE__*/jsx("path", {
      d: "M38.5 19a7.5 7.5 0 017.5 7.5V31h-3l-1.5 12h-6"
    }), /*#__PURE__*/jsx("circle", {
      cx: "23.5",
      cy: "7",
      r: "6"
    }), /*#__PURE__*/jsx("path", {
      d: "M34 26.5a10.5 10.5 0 10-21 0V31h4.5L19 46h9l1.5-15H34z"
    })]
  });
};

export { PM2GroupIcon };
//# sourceMappingURL=group.js.map
